import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'lang-translate',
  templateUrl: './lang-translate.component.html',
  styleUrls: ['./lang-translate.component.scss']
})
export class LangTranslateComponent implements OnInit {

  activeLang = 1;
  currentLang = 'ru';
  langs = [
    { name: 'be', label: 'BE' },
    { name: 'ru', label: 'RU' },
    { name: 'en', label: 'EN' }
  ];
  constructor(private cookieService: CookieService) { 
    // console.log('start', `${localStorage.getItem('_tr_lang')}==${this.cookieService.get('googtrans')}`);
    // if (this.getInsideLang(localStorage.getItem('_tr_lang')) != this.cookieService.get('googtrans') ) {
    //   this.changeLang(localStorage.getItem('_tr_lang'));
    // }
    this.currentLang = this.cookieService.get('googtrans').replace('/ru/','');
    if (this.currentLang === 'be') {
      this.activeLang = 0;
    } else if (this.currentLang === 'ru') {
      this.activeLang = 1;
    } if (this.currentLang === 'en') {
      this.activeLang = 2;
    }
  }

  getInsideLang = (lang) => {
    if (lang !== 'ru') {
      return '/ru/'+lang;
    } else {
      return null;
    }
  }
  // test() {
  //   this.cookieService.set('test', 'Hello World');

  // }
  // test2(){
  //   this.cookieService.delete('test');

  // }
  // test3(){
  //   this.cookieService.delete('googtrans');

  // }
  changeLang(lang) {
    // if (lang !== 'ru') {
      // if (window.location.hostname === 'pogoda.solut.tech') {
      //   this.cookieService.set('googtrans', '/ru/'+lang, null, '/', 'pogoda.solut.tech', true);
      // } else if (window.location.hostname === 'new.pogoda.by') {
      //   this.cookieService.set('googtrans', '/ru/'+lang, null, '/', 'new.pogoda.by', true);
      // } else if (window.location.hostname === 'sub.hackdx.md') {
        // console.log('click !ru');
        // debugger;

        this.cookieService.set('googtrans', '/ru/'+lang);
        this.cookieService.delete('googtrans', '/', 'pogoda.by');
        // this.cookieService.set('googtrans', '/ru/'+lang, null, '/', 'hackdx.md', true);
        // this.cookieService.set('googtrans', '/ru/'+lang, null, '/', 'sub.hackdx.md', false);
        // this.cookieService.set('googtrans', '/ru/'+lang, null, '/', '.sub.hackdx.md', false);
      // } else {
      //   this.cookieService.set('googtrans', '/ru/'+lang);
      // }
    // } else {
    //   // if(window.location.hostname === 'pogoda.solut.tech') {
    //   //   this.cookieService.set('googtrans', null, null, '/', '.solut.tech', true);
    //   // }
    //   // this.cookieService.delete('googtrans');
    //   console.log('click ru');
    //   // this.cookieService.deleteAll();


    //   this.cookieService.set('googtrans', '/ru/ru');
    //   // this.cookieService.set('googtrans', '/ru/ru', null, '/', 'hackdx.md', true);
    //   // this.cookieService.set('googtrans', '/ru/ru', null, '/', 'sub.hackdx.md', false);
    //   // this.cookieService.set('googtrans', '/ru/ru', null, '/', '.sub.hackdx.md', false);
    //   // this.cookieService.set('googtrans', null);
    // }
    localStorage.setItem("_tr_lang", lang);
    // console.log(this.cookieService.get('googtrans'));
    window.location.reload();
  }

  ngOnInit() {
  }

}
